import { TFunction } from 'i18next';

import { convertMaxWin } from './fortuneWheel';
import {
  BonusAttributeField,
  Currency,
  Lootbox,
  LootboxBonus,
  LootboxBonusType,
} from '@/api/common';
import { amountWithCurrencySymbol, CurrencyCode } from '@/helpers/currency';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';

export const LOOTBOX_DICE_TITLES = ['Dice_roll', 'dice_roll'];

export const isDiceLootbox = (lootbox: Lootbox) =>
  LOOTBOX_DICE_TITLES.some((LOOTBOX_DICE_TITLES) =>
    lootbox.title.includes(LOOTBOX_DICE_TITLES)
  );

export const getDiceRollBonusAmount = (
  bonus: LootboxBonus,
  currencies: Currency[]
) => {
  if (bonus?.type === LootboxBonusType.Freespins) {
    const attribute = bonus?.attributes.find(
      (item) => item.field === BonusAttributeField.FreespinsCount
    );

    if (!attribute || typeof attribute.value !== 'number') return;

    return attribute.value;
  }

  const bonusAmounts = bonus.attributes?.find(
    ({ field }) => field === BonusAttributeField.BonusAmount
  )?.value;

  if (typeof bonusAmounts === 'number' || !bonusAmounts) return;

  const prizeObj = bonusAmounts.find(
    (bonus) => bonus.currency === CurrencyCode.USD
  );

  if (!prizeObj) return;

  const formattedPrize = getCurrencyCentsAndCode(
    prizeObj.amountCents,
    prizeObj.currency,
    currencies
  );

  const prize = amountWithCurrencySymbol(
    CurrencyCode.USD,
    formattedPrize.amount,
    { wholeRounding: true }
  );

  return prize;
};

export const getDiceRollLootboxCashBonusType = (
  bonus: LootboxBonus,
  currency: string,
  currencies: Currency[]
) => {
  const bonusAmounts = bonus.attributes?.find(
    ({ field }) => field === BonusAttributeField.BonusAmount
  )?.value;

  if (typeof bonusAmounts === 'number' || !bonusAmounts) return;

  const prizeObj = bonusAmounts.find((bonus) => bonus.currency === currency);

  if (!prizeObj) return;

  const formattedPrize = getCurrencyCentsAndCode(
    prizeObj.amountCents,
    prizeObj.currency,
    currencies
  );

  const prize = amountWithCurrencySymbol(
    formattedPrize.currency,
    formattedPrize.amount,
    { wholeRounding: true }
  );

  const maxWin = convertMaxWin(bonusAmounts, currencies);

  const wager = bonus.attributes?.find(
    ({ field }) => field === BonusAttributeField.Wager
  )?.value;

  return {
    prize,
    maxWin,
    wager,
  };
};

export const getDiceRollLootboxFreespinsType = (
  bonus: LootboxBonus,
  currencies: Currency[],
  t: TFunction
) => {
  const freespinsAmount = bonus?.attributes.find(
    (item) => item.field === BonusAttributeField.FreespinsCount
  );

  if (!freespinsAmount || typeof freespinsAmount.value !== 'number') return;

  const bonusAmounts = bonus.attributes?.find(
    ({ field }) => field === BonusAttributeField.FreespinsMaxWin
  )?.value;

  if (typeof bonusAmounts === 'number' || !bonusAmounts) return;

  const maxWin = convertMaxWin(bonusAmounts, currencies);

  const prize = t('amountShortFS', { amount: freespinsAmount.value });

  return {
    prize,
    maxWin,
    wager: undefined,
  };
};
